var ResourceKeys = {
    TITLE: 'default.store.title.com'
};
export default ResourceKeys;
